import { extractApiErrorCode, extractApiErrorMessage } from './errorMessage';
import { AuthErrorCode } from './authErrorCodes';

type TranslateFn = (key: string, options?: any) => string;

/**
 * Resolve the message shown to the user after a failed login.
 *
 * The /auth/* endpoints answer every credential failure with a single generic code, so there is no
 * per-reason text to surface. Map that code to a translated string rather than echoing the backend's
 * English message, and keep the generic extraction as a fallback for anything else (network errors,
 * validation errors, unexpected 500s).
 */
export function getLoginErrorMessage(error: unknown, t: TranslateFn): string {
  const code = extractApiErrorCode(error);

  // A deactivated account is a dead end the user cannot clear by retrying, so it gets its own text
  // rather than the generic failure - otherwise they keep trying a password that is in fact correct.
  if (code === AuthErrorCode.AccountDeactivated) {
    return t('f-login-deactivated');
  }

  if (code === AuthErrorCode.AuthenticationFailed) {
    return t('f-login-failed');
  }

  return extractApiErrorMessage(error, { fallback: t('f-login-failed') });
}
